import React from 'react'
import { states } from '@/legacy/components/v2/ribbons/states'
import ActivityRibbonBase from './activityRibbonBase'
import { activityRibbonMap } from '@/legacy/components/v2/ribbons/types'
export default function OralExamRibbon(props) {
  const { exor } = activityRibbonMap
  return (
    <ActivityRibbonBase
      Icon={exor.icon}
      type={exor.type}
      calendarLabel="components.ribbon.student.calendarLabel"
      {...props}
    />
  )
}

OralExamRibbon.defaultProps = {
  subject: {},
  state: states.DEFAULT,
  buttonEnabled: true,
  buttonLabel: 'generic.play',
  buttonProps: {},
  messages: 0,
}
